import { combineReducers } from 'redux';

import shipping from './shipping';
import deliveryPoints from './deliveryPoints';


export default combineReducers({
  shipping,
  deliveryPoints,
});
